import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { fetchSpikeStatus } from './api';

/** On the hello page, only when the spike is on. An installed app has no address bar. */
export function SpikeLink() {
  const status = useQuery({ queryKey: ['spike-status'], queryFn: fetchSpikeStatus, retry: false });
  if (!status.data?.enabled) return null;
  return (
    <p className="spike-link">
      <Link to="/spike">Open the iPhone test page →</Link>
    </p>
  );
}
